import { apiService } from 'services';

export const emailForgotPassword = (email: string) => apiService.post('/users/reset-password', { email });

export const passwordChange = (uid: string, currentPassword: string, newPassword: string) =>
  apiService.post('/passwordChange', { uid, currentPassword, newPassword });

export const deleteUser = () => apiService.delete('/users');

export const cancelUserDeletion = () => apiService.post('/users/cancel-user-deletion', undefined);

export const updateUser = (data: Record<string, any>) => apiService.put('/users', data);

export const checkIfHasUsedApps = () => apiService.get<{ junior: boolean; teen: boolean }>('/users/has-used-app');
